// extracted by mini-css-extract-plugin
export default {"mainDiv":"LoadingField_mainDiv__jgsH+"};